import PageHeader from "../components/PageHeader";
import HireCMSDeveloperContent from "../components/Hire-Cms-Developer-Content";

const HireCmsDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Cms Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Cms Developer" image="/images/cms-development.jpg" />
            <HireCMSDeveloperContent />
        </>
    )
}

export default HireCmsDevelopers;